import { Controller } from "@hotwired/stimulus"

// Pins the mobile modal sheet to the visual viewport while the iOS keyboard
// is open — fixed elements track the layout viewport, so without this the
// sheet drifts and leaves a void above the keyboard.
export default class extends Controller {
  static targets = ["card"]

  connect() {
    if (!window.visualViewport) return

    this.onViewportChange = this.onViewportChange.bind(this)
    window.visualViewport.addEventListener("resize", this.onViewportChange)
    window.visualViewport.addEventListener("scroll", this.onViewportChange)
  }

  disconnect() {
    if (!window.visualViewport) return

    window.visualViewport.removeEventListener("resize", this.onViewportChange)
    window.visualViewport.removeEventListener("scroll", this.onViewportChange)
    this.reset()
  }

  onViewportChange() {
    const viewport = window.visualViewport
    const keyboardHeight = window.innerHeight - viewport.height
    const desktop = window.matchMedia("(min-width: 1024px)").matches

    if (desktop || keyboardHeight < 80) {
      this.reset()
      return
    }

    this.element.style.height = `${viewport.height}px`
    this.element.style.transform = `translateY(${viewport.offsetTop}px)`
    if (this.hasCardTarget) this.cardTarget.style.maxHeight = "100%"
  }

  reset() {
    this.element.style.height = ""
    this.element.style.transform = ""
    if (this.hasCardTarget) this.cardTarget.style.maxHeight = ""
  }
}
